import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import DepictMolecule from 'components/DepictMolecule';
import { SearchResult } from 'features/searchMolecules/searchMoleculesSlice';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    summaryContainer: {
      padding: theme.spacing(2, 2, 0, 2),
    },
  }),
);

interface Props {
  selectedResultMemberCount?: number;
  selectedResult: SearchResult;
}

const Summary = ({ selectedResultMemberCount, selectedResult }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'results']);

  return (
    <div className={classes.summaryContainer}>
      <Typography variant="h6" gutterBottom>
        {t('results:header_current_query')}
      </Typography>
      <DepictMolecule smiles={selectedResult.refmol} width={100} height={100} />
      <Typography display="block" variant="caption">
        <time>
          {DateTime.fromMillis(selectedResult.timeOfResultAcquisition).toLocaleString(
            DateTime.DATETIME_SHORT,
          )}
        </time>
      </Typography>
      <Typography display="block" variant="caption">
        {selectedResultMemberCount ?? 0} {t('molecules')}
      </Typography>
      <Typography display="block" variant="caption">
        {selectedResult.groups.length} {t('results:groups')}
      </Typography>
    </div>
  );
};

export default Summary;
